<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditDialog')"
    >
      <el-form
        ref="dialogAddEditForm"
        :model="dialogAddEditForm"
        :rules="dialogAddEditFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="店名(专卖证)"
                  prop="storeName"
                >
                  <el-input
                    v-model="dialogAddEditForm.storeName"
                    maxlength="64"
                    placeholder="请输入店名"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="地址(专卖证)"
                  prop="address"
                >
                  <el-input
                    v-model="dialogAddEditForm.address"
                    maxlength="256"
                    placeholder="请输入地址"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="专卖证号"
                  prop="certificateNo"
                >
                  <el-input
                    v-model="dialogAddEditForm.certificateNo"
                    maxlength="12"
                    placeholder="请输入专卖证号"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="实际店名"
                  prop="realStoreName"
                >
                  <el-input
                    v-model="dialogAddEditForm.realStoreName"
                    maxlength="64"
                    placeholder="请输入实际店名"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="实际地址"
                  prop="realAddress"
                >
                  <el-input
                    v-model="dialogAddEditForm.realAddress"
                    maxlength="256"
                    placeholder="请输入实际地址"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="专卖证有效截止日期"
                  prop="certificateEndDate"
                >
                  <el-date-picker
                    v-model="dialogAddEditForm.certificateEndDate"
                    type="date"
                    style="width: 100%;"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="邮寄地址"
                  prop="mailAddress"
                >
                  <el-input
                    v-model="dialogAddEditForm.mailAddress"
                    maxlength="256"
                    placeholder="请输入邮寄地址"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="所属省区"
                  prop="provinceId"
                >
                  <el-select
                    v-model="dialogAddEditForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="changeProvinceFun"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属城市"
                  prop="cityId"
                >
                  <el-select
                    v-model="dialogAddEditForm.cityId"
                    filterable
                    clearable
                    placeholder="请选择城市"
                    style="width:100%"
                    @change="changeCityFun"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属区县"
                  prop="countyId"
                >
                  <el-select
                    v-model="dialogAddEditForm.countyId"
                    filterable
                    clearable
                    placeholder="请选择区县"
                    style="width:100%"
                    @change="changeCountyFun"
                  >
                    <el-option
                      v-for="item in countyOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="档位"
                  prop="level"
                >
                  <el-select
                    v-model="dialogAddEditForm.level"
                    filterable
                    clearable
                    placeholder="请选择档位"
                    style="width:100%"
                    @change="changeLevelFun"
                  >
                    <el-option
                      v-for="item in levelOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="零售户类型"
                  prop="storeSort"
                >
                  <el-select
                    v-model="dialogAddEditForm.storeSort"
                    filterable
                    clearable
                    placeholder="请选择零售户类型"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in storeSortOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="店铺业态"
                  prop="storeType"
                >
                  <el-select
                    v-model="dialogAddEditForm.storeType"
                    filterable
                    clearable
                    placeholder="请选择店铺业态"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in storeTypeOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="卷烟经营"
                  prop="cigaretteBusiness"
                >
                  <el-select
                    v-model="dialogAddEditForm.cigaretteBusiness"
                    filterable
                    clearable
                    placeholder="请选择卷烟经营"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in cigaretteBusinessOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="商圈"
                  prop="businessDistrictId"
                >
                  <el-select
                    v-model="dialogAddEditForm.businessDistrictId"
                    filterable
                    clearable
                    placeholder="请选择商圈"
                    style="width:100%"
                    @change="changeBusinessDistrictFun"
                  >
                    <el-option
                      v-for="item in businessDistrictOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="自律小组组长"
                  prop="isSelfDisciplineGroupLeader"
                >
                  <el-radio-group v-model="dialogAddEditForm.isSelfDisciplineGroupLeader">
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="2">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="可以开展一桌式品鉴"
                  prop="ableHoldTaste"
                >
                  <el-radio-group v-model="dialogAddEditForm.ableHoldTaste">
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="2">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="维护人"
                  prop="manageUserIds"
                >
                  <el-select
                    v-if="eventType === 'add'"
                    v-model="dialogAddEditForm.manageUserIds"
                    filterable
                    clearable
                    multiple
                    placeholder="请选择维护人"
                    style="width:100%"
                    @change="changeManageUserFun"
                  >
                    <el-option
                      v-for="item in manageUserOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditForm.manageUserName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="走访维护人"
                  prop="interviewMaintainerId"
                >
                  <el-select
                    v-model="dialogAddEditForm.interviewMaintainerId"
                    filterable
                    clearable
                    placeholder="请选择走访维护人"
                    style="width:100%"
                    @change="handleInterviewMaintainerChange"
                  >
                    <el-option
                      v-for="item in manageUserOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="零售户标签"
                  prop="checkedTags"
                >
                  <el-select
                    v-model="dialogAddEditForm.checkedTags"
                    v-defaultSelect="[dialogAddEditForm.checkedTags,storeTagOptions,'data','disabled',true]"
                    multiple
                    clearable
                    placeholder="请选择零售户标签"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in storeTagOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                      :disabled="item.disabled"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  label="应用分类"
                  prop="checkedTypes"
                >
                  <el-checkbox-group v-model="dialogAddEditForm.checkedTypes">
                    <el-checkbox
                      v-for="(item) in terminalTypeOptions"
                      :key="item.data"
                      :label="item.data"
                    >
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            联系信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="店主姓名"
                  prop="ownerName"
                >
                  <el-input
                    v-model="dialogAddEditForm.ownerName"
                    maxlength="32"
                    placeholder="请输入店主姓名"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="性别">
                  <el-radio-group v-model="dialogAddEditForm.gender">
                    <el-radio
                      v-for="(item) in genderOptions"
                      :key="item.data"
                      :label="item.data"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系电话"
                  prop="phone"
                >
                  <el-input
                    v-model="dialogAddEditForm.phone"
                    maxlength="16"
                    placeholder="请输入联系电话"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="本香注册号码"
                  prop="benxiangNo"
                >
                  <el-input
                    v-model="dialogAddEditForm.benxiangNo"
                    maxlength="16"
                    placeholder="请输入本香注册号码"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="联系人1"
                  prop="linkman1"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman1"
                    placeholder="请输入联系人1"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系人1与店主关系"
                  prop="linkman1Relation"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman1Relation"
                    placeholder="请输入联系人1与店主关系"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系人1电话"
                  prop="linkman1Phone"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman1Phone"
                    placeholder="请输入联系人1电话"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="本香门店编码"
                  prop="benxiangStoreNo"
                >
                  <el-input
                    v-model="dialogAddEditForm.benxiangStoreNo"
                    maxlength="14"
                    placeholder="请输入本香门店编码"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="联系人2"
                  prop="linkman2"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman2"
                    placeholder="请输入联系人2"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系人2与店主关系"
                  prop="linkman2Relation"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman2Relation"
                    placeholder="请输入联系人2与店主关系"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系人2电话"
                  prop="linkman2Phone"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman2Phone"
                    placeholder="请输入联系人2电话"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="到货时间"
                  prop="receiptDay"
                >
                  <el-select
                    v-model="dialogAddEditForm.receiptDay"
                    filterable
                    clearable
                    placeholder="请选择到货时间"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in receiptDayOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            店面形象信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="总背柜组数"
                  prop="totalBackCabinetGroupNum"
                >
                  <el-input-number
                    v-model="dialogAddEditForm.totalBackCabinetGroupNum"
                    :min="0"
                    :max="1000"
                    :step="1"
                    step-strictly
                    style="width:90%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="总背柜格数"
                  prop="totalBackCabinetGridNum"
                >
                  <el-input-number
                    v-model="dialogAddEditForm.totalBackCabinetGridNum"
                    :min="0"
                    :max="1000"
                    :step="1"
                    step-strictly
                    style="width:90%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="总地柜组数"
                  prop="totalFloorCabinetGroupNum"
                >
                  <el-input-number
                    v-model="dialogAddEditForm.totalFloorCabinetGroupNum"
                    :min="0"
                    :max="1000"
                    :step="1"
                    step-strictly
                    style="width:90%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="店面面积"
                  prop="storeArea"
                >
                  <el-select
                    v-model="dialogAddEditForm.storeArea"
                    filterable
                    clearable
                    placeholder="请选择店面面积"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in storeAreaOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box pic-container">
          <h3 class="modal-title">
            专卖证照片信息<span style="padding-left:30px;color:red">上传图片大小：小于5M; 格式：png、jpg、jpeg、gif</span>
          </h3>
          <div class="modal-row-box">
            <el-upload
              ref="picOneUpload"
              list-type="picture-card"
              :action="picUploadAction"
              :data="picData"
              :before-upload="beforeOneUpload"
              :file-list="initOneFileList"
              :on-preview="handlePictureCardPreview"
              :headers="{'X-Token': getToken()}"
              :limit="1"
              accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
              :with-credentials="true"
              :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picOneList)}"
              :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picOneList)"
            >
              <el-button
                type="success"
                class="upload-button"
                icon="el-icon-folder-opened"
              >
                选择图片
              </el-button>
            </el-upload>
          </div>
        </div>
        <div class="modal-box pic-container">
          <h3 class="modal-title">
            照片信息<span style="padding-left:30px;color:red">上传图片大小：小于5M; 格式：png、jpg、jpeg、gif</span>
          </h3>
          <div class="modal-row-box">
            <el-upload
              ref="picUpload"
              list-type="picture-card"
              :action="picUploadAction"
              :data="picData"
              :before-upload="beforeAvatarUpload"
              :file-list="initFileList"
              :on-preview="handlePictureCardPreview"
              :headers="{'X-Token': getToken()}"
              multiple
              :limit="10"
              accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
              :with-credentials="true"
              :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
              :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
            >
              <el-button
                type="success"
                class="upload-button"
                icon="el-icon-folder-opened"
              >
                选择图片
              </el-button>
            </el-upload>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditForm.remark"
                    type="textarea"
                    placeholder="备注"
                    maxlength="128"
                    style="margin-top:10px;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
import { getToken } from "@/utils/auth"
import { deleteFileApi } from '@/api/common'
// 用户API
import { loadUserSelectDataByUserTypeApi } from '@/api/user'
// 档位API
import { listStoreLevelSettingApi } from '@/api/v2/storeLevelSetting'
// 商圈API
import { listBusinessDistrictSettingApi } from '@/api/v2/businessDistrictSetting'
// 零售户标签API
import { listStoreTagApi } from '@/api/v2/storeTag'
// 零售户档案API
import { saveStoreInfoApi, viewStoreInfoApi } from '@/api/v2/store'
// 区域API
import { listAreaApi } from '@/api/v2/area'
// 数据字典API
import { listDictApi } from '@/api/v2/dict'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        // return callback(new Error('手机号不能为空'));
        return callback();
      } else {
        const reg = /^1[3|4|5|6|7|8|9]\d{9}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号码'));
        }
      }
    }
    // 本香门店码
    const validateBenxiangStoreNo = (rule, value, callback) => {
      if (!value) {
        return callback();
      } else if (value.length != 14 && value.length != 12) {
        return callback(new Error('本香门店码只能是 12 或 14 位'));
      } else {
        return callback();
      }
    }
    return {
      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        storeName: [{ required: true, message: '请输入店名', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        realStoreName: [{ required: true, message: '请输入实际店名', trigger: 'blur' }],
        realAddress: [{ required: true, message: '请输入实际地址', trigger: 'blur' }],
        mailAddress: [{ required: true, message: '请输入邮寄地址', trigger: 'blur' }],
        provinceId: [{ required: true, message: '请选择所属省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择所属城市', trigger: 'change' }],
        countyId: [{ required: true, message: '请选择所属区县', trigger: 'change' }],
        certificateNo: [
          { required: true, message: '请输入专卖证号', trigger: 'blur' },
          { min: 12, max: 12, message: '专卖证号必须是12位', trigger: 'blur' }
        ],
        certificateEndDate: [{ required: false, message: '请选择填报时间', trigger: 'blur' }],
        level: [{ required: true, message: '请选择档位', trigger: 'change' }],
        storeType: [{ required: true, message: '请选择店铺业态', trigger: 'change' }],
        cigaretteBusiness: [{ required: true, message: '请选择卷烟经营', trigger: 'change' }],
        businessDistrictId: [{ required: false, message: '请选择商圈', trigger: 'change' }],
        isSelfDisciplineGroupLeader: [{ required: false, message: '请选择是否自律小组组长', trigger: 'change' }],
        ableHoldTaste: [{ required: false, message: '请选择是否可以开展一桌式品鉴', trigger: 'change' }],
        manageUserIds: [{ required: true, message: '请选择维护人', trigger: 'change' }],
        interviewMaintainerId: [{ required: true, message: '请选择走访维护人', trigger: 'change' }],
        storeSort: [{ required: true, message: '请选择零售户类型', trigger: 'change' }],
        checkedTypes: [{ type: 'array', required: true, message: '请至少选择一个应用分类', trigger: 'change' }],
        ownerName: [{ required: true, message: '请输入店主姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }, { validator: checkPhone, trigger: 'blur' }],
        benxiangNo: [{ required: false, message: '请输入本香号码', trigger: 'blur' }, { validator: checkPhone, trigger: 'blur' }],
        benxiangStoreNo: [{ validator: validateBenxiangStoreNo, trigger: 'blur' }],
        receiptDay: [{ required: false, message: '请选择到货时间', trigger: 'change' }],
        storeArea: [{ required: false, message: '请选择店面面积', trigger: 'change' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      countyOptions: [],
      levelOptions: [],
      storeTypeOptions: [],
      cigaretteBusinessOptions: [],
      businessDistrictOptions: [],
      manageUserOptions: [],
      storeSortOptions: [],
      storeAreaOptions: [],
      genderOptions: [],
      terminalTypeOptions: [],
      storeTagOptions: [],
      receiptDayOptions: [],
      picData: { directory: 'storeInfo', sort: 999 },
      picUploadAction: process.env.VUE_APP_BASE_API + '/web/common/uploadFile',
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: process.env.VUE_APP_BASE_API,
      initOneFileList: [],
      picOneList: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.provinceOptions = []
        _this.cityOptions = []
        _this.countyOptions = []
        _this.levelOptions = []
        _this.storeTypeOptions = []
        _this.cigaretteBusinessOptions = []
        _this.businessDistrictOptions = []
        _this.manageUserOptions = []
        _this.storeSortOptions = []
        _this.storeAreaOptions = []
        _this.genderOptions = []
        _this.terminalTypeOptions = []
        _this.storeTagOptions = []
        _this.receiptDayOptions = []
        _this.picList = []
        _this.initFileList = []
        _this.picOneList = []
        _this.initOneFileList = []
        _this.dialogAddEditForm = {
          storeName: '',
          address: '',
          realStoreName: '',
          realAddress: '',
          mailAddress: '',
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          countyId: '',
          countyName: '',
          certificateNo: '',
          certificateEndDate: '',
          levelStr: '',
          level: '',
          storeType: '',
          cigaretteBusiness: '',
          businessDistrictId: '',
          businessDistrictName: '',
          isSelfDisciplineGroupLeader: 2,
          ableHoldTaste: 2,
          manageUserIds: [],
          manageUserId: '',
          manageUserName: '',
          interviewMaintainerId: '',
          interviewMaintainerName: '',
          storeSort: 3,
          checkedTypes: [],
          checkedTags: [],
          ownerName: '',
          gender: 1,
          phone: '',
          linkman1: '',
          linkman1Relation: '',
          linkman1Phone: '',
          linkman2: '',
          linkman2Relation: '',
          linkman2Phone: '',
          benxiangNo: '',
          benxiangStoreNo: '',
          totalBackCabinetGroupNum: 0,
          totalBackCabinetGridNum: 0,
          totalFloorCabinetGroupNum: 0,
          receiptDay: '',
          storeArea: 1,
          remark: '',
          billType: 1
        }
        _this.initProvinceSelectData()
        _this.loadDictData()
        _this.initManageUserSelectData()
        _this.initStoreTagCheckData()
        if (_this.eventType !== 'add') {
          _this.initData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    getToken,
    // 初始省区下拉数据
    initProvinceSelectData () {
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    changeProvinceFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.provinceOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.provinceName = selectItem ? selectItem.label : ''
      _this.cityOptions = []
      _this.countyOptions = []
      _this.businessDistrictOptions = []
      _this.levelOptions = []
      _this.dialogAddEditForm.cityName = ''
      _this.dialogAddEditForm.cityId = null
      _this.dialogAddEditForm.countyName = ''
      _this.dialogAddEditForm.countyId = null
      _this.dialogAddEditForm.businessDistrictName = ''
      _this.dialogAddEditForm.businessDistrictId = null
      _this.dialogAddEditForm.level = ''
      if (val) {
        _this.initCitySelectData(val)
        _this.initLevelSelectData(val)
      }
    },
    // 初始城市下拉数据
    initCitySelectData (val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    changeCityFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.cityOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.cityName = selectItem ? selectItem.label : ''
      _this.countyOptions = []
      _this.businessDistrictOptions = []
      _this.dialogAddEditForm.countyName = ''
      _this.dialogAddEditForm.countyId = null
      _this.dialogAddEditForm.businessDistrictName = ''
      _this.dialogAddEditForm.businessDistrictId = null
      if (val) {
        _this.initCountySelectData(val)
      }
    },
    // 初始区县下拉数据
    initCountySelectData (val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.countyOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择区县回调
    changeCountyFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.countyOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.countyName = selectItem ? selectItem.label : ''
      _this.businessDistrictOptions = []
      _this.dialogAddEditForm.businessDistrictName = ''
      _this.dialogAddEditForm.businessDistrictId = null
      if (val) {
        _this.initBusinessDistrictSelectData(val)
      }
    },
    // 初始档位下拉数据
    initLevelSelectData (val) {
      listStoreLevelSettingApi({ provinceId: val }).then((response) => {
        const { data } = response
        data.forEach(item => {
          this.levelOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 档位回调
    changeLevelFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.levelOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.levelStr = selectItem ? selectItem.label : ''
    },
    // 获取数据字典中的数据
    loadDictData () {
      let _this = this;
      let types = "6,7,8,11,15,30,38";
      listDictApi({ types: types }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          // 店铺业态
          if (item.type === 6) {
            _this.storeTypeOptions.push({ label: item.optionLabel, data: item.optionValue })
          }
          // 卷烟经营
          if (item.type === 7) {
            _this.cigaretteBusinessOptions.push({ label: item.optionLabel, data: item.optionValue })
          }
          // 应用分类
          if (item.type === 8) {
            _this.terminalTypeOptions.push({ label: item.optionLabel, data: item.optionValue })
          }
          // 店面面积
          if (item.type === 11) {
            _this.storeAreaOptions.push({ label: item.optionLabel, data: item.optionValue })
          }
          // 性别
          if (item.type === 15) {
            _this.genderOptions.push({ label: item.optionLabel, data: item.optionValue })
          }
          // 零售户类型
          if (item.type === 30) {
            _this.storeSortOptions.push({ label: item.optionLabel, data: item.optionValue })
          }
          // 到货时间
          if (item.type === 38) {
            _this.receiptDayOptions.push({ label: item.optionLabel, data: item.optionValue })
          }

        })
      })
    },
    // 初始商圈下拉数据
    initBusinessDistrictSelectData (val) {
      listBusinessDistrictSettingApi({ countyId: val }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.businessDistrictOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 商圈回调
    changeBusinessDistrictFun (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.businessDistrictOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.businessDistrictName = selectItem ? selectItem.label : ''
    },
    // 初始维护人下拉数据
    initManageUserSelectData () {
      loadUserSelectDataByUserTypeApi().then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.manageUserOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 维护人回调
    changeManageUserFun (val) {
      let _this = this;
      let userNames = ''
      let userIds = ''
      val.forEach(idItem => {
        let selectItem = {}
        selectItem = _this.manageUserOptions.find(item => {
          return item.data === idItem
        })
        if (selectItem) {
          userNames += ',' + selectItem.label
          userIds += ',' + selectItem.data
        }
      })
      if (userNames.length > 0) {
        _this.dialogAddEditForm.manageUserName = userNames.substring(1)
        _this.dialogAddEditForm.manageUserId = userIds.substring(1)
      } else {
        _this.dialogAddEditForm.manageUserName = ''
        _this.dialogAddEditForm.manageUserId = ''
      }
    },
    // 走访维护人回调
    handleInterviewMaintainerChange (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.manageUserOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.interviewMaintainerName = selectItem ? selectItem.label : ''
    },
    // 初始零售户标签复选框数据
    initStoreTagCheckData () {
      listStoreTagApi().then((response) => {
        const { data } = response;
        data.forEach(item => {
          let disabledValue = false
          if (item.status === 2) {
            disabledValue = true
          }
          this.storeTagOptions.push({ label: item.name + '(' + item.provinceName + ')', data: item.id, name: item.name, disabled: disabledValue })
        })
      })
    },
    // 图片上传前
    beforeOneUpload (file) {
      let _this = this;
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        _this.$message.error('上传图片大小不能超过5MB!')
        return false
      }
      if (_this.picOneList.length === 1) {
        _this.$message.error('最多上传1张图片!')
        return false
      }
      _this.isUploading = true
    },
    // 图片上传前
    beforeAvatarUpload (file) {
      let _this = this;
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        _this.$message.error('上传图片大小不能超过5MB!')
        return false
      }
      if (_this.picList.length === 3) {
        _this.$message.error('最多上传3张图片!')
        return false
      }
      _this.isUploading = true
    },
    // 预览
    handlePictureCardPreview (file) {
      let _this = this;
      _this.dialogImageUrl = file.url
      _this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess (res, file, fileList, dataObj) {
      let _this = this;
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = _this.baseUrl + res.fileName
        dataObj.push(fileObj)
        _this.isUploading = false
      } else {
        _this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove (file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 加载数据
    initData () {
      let _this = this;
      viewStoreInfoApi({ id: _this.dataId }).then(res => {
        const { data } = res
        for (let key in _this.dialogAddEditForm) {
          if (key !== 'checkedTypes' && key !== 'checkedTags' && key !== 'manageUserIds') {
            _this.dialogAddEditForm[key] = data[key]
          }
        }
        _this.dialogAddEditForm.interviewMaintainerId = data.interviewMaintainerId === 0 ? '' : data.interviewMaintainerId;
        _this.dialogAddEditForm.receiptDay = data.receiptDay === 0 ? '' : data.receiptDay;
        _this.dialogAddEditForm.businessDistrictId = data.businessDistrictId === 0 ? '' : data.businessDistrictId;
        _this.dialogAddEditForm.manageUserIds = data.manageUserId.split(',')
        _this.dialogAddEditForm.id = data.id

        if (data.terminalTypeIds && data.terminalTypeIds.length > 0) {
          data.terminalTypeIds.split(',').forEach(item => {
            _this.dialogAddEditForm.checkedTypes.push(Number(item))
          })
        }
        if (data.storeTagIds && data.storeTagIds.length > 0) {
          data.storeTagIds.split(',').forEach(item => {
            _this.dialogAddEditForm.checkedTags.push(Number(item))
          })
        }
        for (let i = 1; i <= 3; i++) {
          if (data['pic' + i] && data['pic' + i] !== '') {
            let obj = {}
            obj.name = data['pic' + i]
            obj.url = _this.baseUrl + data['pic' + i]
            obj.attachmentName = data['pic' + i]
            obj.attachmentUrl = data['pic' + i]
            _this.picList.push(obj)
            _this.initFileList.push(obj)
          }
        }
        if(data.certificatePic && data.certificatePic.length > 0){
          let obj = {}
          obj.name = data.certificatePic
          obj.url = _this.baseUrl + data.certificatePic
          obj.attachmentName = data.certificatePic
          obj.attachmentUrl = data.certificatePic
          _this.picOneList.push(obj)
          _this.initOneFileList.push(obj)
        }
        _this.initLevelSelectData(data.provinceId)
        _this.initCitySelectData(data.provinceId)
        _this.initCountySelectData(data.cityId)
        _this.initBusinessDistrictSelectData(data.countyId)
      })
    },
    modalClose () {
      let _this = this;
      // 直接修改父组件的属性
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '零售户档案', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            // 应用分类
            let terminalTypeIds = ''
            let terminalTypeNames = ''
            _this.dialogAddEditForm.checkedTypes.forEach(item => {
              terminalTypeIds += ',' + item
              let selectItem = _this.terminalTypeOptions.find(typeItem => {
                return Number(typeItem.data) === Number(item)
              })
              terminalTypeNames += ',' + (selectItem ? selectItem.label : '')
            })
            terminalTypeIds = terminalTypeIds.substring(1)
            terminalTypeNames = terminalTypeNames.substring(1)
            _this.dialogAddEditForm.terminalTypeIds = terminalTypeIds
            _this.dialogAddEditForm.terminalTypeNames = terminalTypeNames
            // 标签
            let storeTagIds = ''
            let storeTagNames = ''
            _this.dialogAddEditForm.checkedTags.forEach(item => {
              storeTagIds += ',' + item
              let selectItem = _this.storeTagOptions.find(tagItem => {
                return Number(tagItem.data) === Number(item)
              })
              storeTagNames += ',' + (selectItem ? selectItem.name : '')
            })
            storeTagIds = storeTagIds.substring(1)
            storeTagNames = storeTagNames.substring(1)
            _this.dialogAddEditForm.storeTagIds = storeTagIds
            _this.dialogAddEditForm.storeTagNames = storeTagNames
            for (let i = 1; i <= 3; i++) {
              _this.dialogAddEditForm['pic' + i] = ''
            }
            if (_this.picList.length > 0) {
              _this.picList.forEach((item, index) => {
                _this.dialogAddEditForm['pic' + (index + 1)] = item.attachmentUrl
              })
            }
            if(_this.picOneList.length > 0){
              _this.dialogAddEditForm.certificatePic = _this.picOneList[0].attachmentUrl
            } else {
              _this.dialogAddEditForm.certificatePic = ''
            }
            saveStoreInfoApi(_this.dialogAddEditForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          })
            .catch(() => { })
        }
      })
    },
  }
}
// 控制下拉多选初始化数据禁用删除
import Vue from "vue";
Vue.directive('defaultSelect', {
  componentUpdated (el, bindings) {
    // values v-model 绑定值
    // options 下拉选项
    // prop 对应 options 中 的 value 属性
    // defaultProp 默认值判断属性
    // defaultValue 默认值判断值
    const [values, options, prop, defaultProp, defaultValue] = bindings.value
    // 需要隐藏的标签索引
    const indexs = []
    const tempData = values.map(a => options.find(op => op[prop] === a))
    tempData.forEach((a, index) => {
      if (a[defaultProp] === defaultValue) indexs.push(index)
    })
    const dealStyle = function (tags) {
      tags.forEach((el, index) => {
        if (indexs.includes(index) && ![...el.classList].includes('select-tag-close-none')) {
          el.classList.add('none')
        }
      })
    }
    // 设置样式 隐藏close icon
    const tags = el.querySelectorAll('.el-tag__close')
    if (tags.length === 0) {
      // 初始化tags为空处理
      setTimeout(() => {
        const tagTemp = el.querySelectorAll('.el-tag__close')
        dealStyle(tagTemp)
      })
    } else {
      dealStyle(tags)
    }
  }
})
</script>
<style lang="scss" scoped>
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 15px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}

::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
</style>
